import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/what-tms-feels-like-article")({
  beforeLoad: () => {
    throw redirect({ to: "/what-tms-feels-like" });
  },
});
